import {createSvgIcon} from '../create-svg-icon';

export const PauseIcon = createSvgIcon(
  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
, 'PauseOutlined');
